export default function getJudgeTypes(community) {
  return {
    test: [
      { label: "Juiz de Arena", _id: "juiz-arena", description: "" },
      {
        _id: "juiz-projeto-pesquisa",
        label: "Juiz de Projeto de Inovação",
        description: "",
      },
      {
        _id: "juiz-core-values",
        label: "Juiz de Core Values",
        description: "",
      },
      {
        _id: "juiz-design-robo",
        label: "Juiz de Design de Robô",
        description: "",
      },
    ],
    "fll-brasil": [
      { label: "Juiz de Arena", _id: "juiz-arena", description: "" },
      {
        _id: "juiz-projeto-pesquisa",
        label: "Juiz de Projeto de Inovação",
        description: "",
      },
      {
        _id: "juiz-core-values",
        label: "Juiz de Core Values",
        description: "",
      },
      {
        _id: "juiz-design-robo",
        label: "Juiz de Design de Robô",
        description: "",
      },
    ],
    "frc-brasil": [
      {
        _id: "juiz-projeto-inovacao",
        label: "Juiz de Projeto de Inovação",
        description: "",
      },
      { _id: "juiz-maquina", label: "Juiz de Maquina", description: "" },
      {
        _id: "juiz-atributo-de-equipe",
        label: "Juiz Atributo de Equipe",
        description: "",
      },
    ],
    "ftc-brasil": [
      { _id: "juiz-arena", label: "Juiz de Arena", description: "" },
      {
        _id: "juiz-inovacao",
        label: "Juiz de Máquina, Criatividade e Inovação",
        description: "",
      },
      {
        _id: "juiz-equipe",
        label: "Juiz de Atributos de Equipe",
        description: "",
      },
    ],
    "f1-brasil": [
      { _id: "juiz-stand", label: "Juiz de Stand", description: "" },
      { _id: "juiz-portfolio", label: "Juiz de Portfólio", description: "" },
      {
        _id: "juiz-marketing",
        label: "Juiz de Marketing e Comunicação",
        description: "",
      },
      { _id: "juiz-engenharia", label: "Juiz de Engenharia", description: "" },
      {
        _id: "juiz-empreendedorismo",
        label: "Juiz de Empreendedorismo Social",
        description: "",
      },
      { _id: "juiz-pista", label: "Juiz de Pista", description: "" },
      { _id: "juiz-escrutinio", label: "Juiz de Escrutínio", description: "" },
    ],
    desafiocovid: [
      { _id: "juiz-pesquisa", label: "Juiz de Pesquisa", description: "" },
      {
        _id: "juiz-empreendedorismo",
        label: "Juiz de Empreendedorismo",
        description: "",
      },
      {
        _id: "juiz-impacto-social",
        label: "Juiz de Impacto Social",
        description: "",
      },
      {
        _id: "juiz-criatividade",
        label: "Juiz de Criatividade e Inovação",
        description: "",
      },
    ],
    desafiorelampago: [
      { _id: "juiz-projeto", label: "Juiz de Projeto", description: "" },
      {
        _id: "juiz-empreendedorismo",
        label: "Juiz de Empreendedorismo",
        description: "",
      },
      { _id: "juiz-solucao", label: "Juiz de Solução", description: "" },
      {
        _id: "juiz-apresentacao",
        label: "Juiz de Apresentação",
        description: "",
      },
    ],
    "fll-open-brazil": [
      { label: "Juiz de Arena", _id: "juiz-arena", description: "" },
      {
        _id: "juiz-projeto-pesquisa",
        label: "Juiz de Projeto de Inovação",
        description: "",
      },
      {
        _id: "juiz-core-values",
        label: "Juiz de Core Values",
        description: "",
      },
      {
        _id: "juiz-design-robo",
        label: "Juiz de Design de Robô",
        description: "",
      },
    ],
    "off-season-sesi-mt": [
      { _id: "juiz-arbitro", label: "Juiz e Arbítro", description: "" },
      {
        _id: "juiz-chefe-arbitro-chefe",
        label: "Juiz Chefe e Arbítro Chefe",
        description: "",
      },
    ],
  }[community];
}



// WEBPACK FOOTER //
// ./src/helpers/events/getJudgeTypes.js